import {decorate, inject, injectable} from '@yosmanyga/di';
import {CredentialType} from '@yosmanyga/base';
import {AuthenticationFrontendWithFacebookApi} from "@yosmanyga/authentication-frontend";
import {AxiosInstance} from './Axios';

class AuthenticationWithFacebookApi implements AuthenticationFrontendWithFacebookApi {
    constructor(private axios: AxiosInstance) {
    }

    complete = async (
        code: string,
        verifier: string
    ): Promise<CredentialType> => {
        const {data}: { data: CredentialType } = await this.axios
            .withLanguage()
            .post('/v1/complete-authentication-with-facebook', {
                code: code,
                verifier: verifier,
            })

        return data;
    };
}

decorate(injectable(), AuthenticationWithFacebookApi);
decorate(inject(AxiosInstance), AuthenticationWithFacebookApi, 0);

export {AuthenticationWithFacebookApi};
